<!-- components/Overlay.vue -->
<template>
    <div class="overlay" v-if="showOverlay" style="z-index: 1">
      <div class="m-loader mr-4">
        <svg class="m-circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
        </svg>
      </div>
      <h3 class="l-text">Loading...</h3>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      showOverlay: {
        type: Boolean,
        default: true,
      }
    },
  };
  </script>
  
  <style scoped>
  /* You can add custom styles specific to the overlay here if needed */
  </style>
  